module.exports = __webpack_public_path__ + "static/media/gcp_logo.0ee7e8c9.png";